import * as React from 'react';
import { useState } from 'react';

// @ts-ignore
import styles from './Address.module.scss?module';
import AddressModal from './AddressModal/AddressModal';
import { IShippingAddress } from '../ShippingAddress';
import { useMutation } from '@tanstack/react-query';
import makeRequest from '../../../../Helper/makeRequest';
import Link from '../../../../Abstracts/Link/Link';
import Button from '../../../../Abstracts/Button/Button';

export default function Address(props: {
  shippingAddress: IShippingAddress;
  editable?: boolean;
  selected?: boolean;
  refetchBasket?: any;
  refetchAddresses?: any;
  is_vts: boolean;
}) {
  const [show, setShow] = useState(false);
  const deleteMutation = useMutation({
    mutationFn: () =>
      makeRequest(
        `/api/onlineshop/basket/shipping-addresses/${props.shippingAddress.id}`,
        'DELETE'
      ),
  });
  const patchMutation = useMutation({
    mutationFn: () =>
      makeRequest(
        `/api/onlineshop/basket/shipping-addresses/${props.shippingAddress.id}?is_vts=${props.is_vts ? '1' : '0'}`,
        'PATCH'
      ),
  });
  return (
    <React.Fragment key={props.shippingAddress.id}>
      <AddressModal
        shippingAddress={props.shippingAddress}
        show={show}
        onHide={() => setShow(false)}
        refetch={() => {
          props?.refetchAddresses();
          if (props.selected) {
            props?.refetchBasket();
          }
        }}
        is_vts={props.is_vts}
      />

      <div>
        <div className={'pb-2'}>
          <strong>{props.shippingAddress.companyName}&nbsp;</strong>
        </div>
        <div>
          {props.shippingAddress.firstName} {props.shippingAddress.lastName}
          &nbsp;
        </div>
        <div>
          {props.shippingAddress.street} {props.shippingAddress.streetNumber}
          &nbsp;
        </div>
        {props.shippingAddress.street2 && (
          <div>{props.shippingAddress.street2}</div>
        )}
        <div>
          {props.shippingAddress.zip} {props.shippingAddress.city}&nbsp;
        </div>
        <div>{props.shippingAddress.country?.name}&nbsp;</div>
        {props.editable && (
          <div className={'pb-3'}>
            <div className={'pt-2'}>
              <Button
                disabled={props.selected}
                loading={patchMutation.isPending}
                className={[
                  props.selected ? styles.selected : '',
                  styles.UseButton,
                ].join(' ')}
                onClick={(event) => {
                  event.preventDefault();
                  patchMutation.mutate(undefined, {
                    onSuccess: () => {
                      props?.refetchBasket();
                    },
                  });
                }}
              >
                {props.selected ? 'Selected' : 'Deliver to this address'}
              </Button>
            </div>
            <div className={''}>
              <Link
                underline={true}
                className={'me-3'}
                onClick={() => setShow(true)}
              >
                Edit
              </Link>
              <Link
                underline={true}
                onClick={(event) => {
                  event.preventDefault();
                  deleteMutation.mutate(undefined, {
                    onSuccess: () => {
                      props?.refetchAddresses();
                      if (props.selected) {
                        props?.refetchBasket();
                      }
                    },
                  });
                }}
              >
                Delete
              </Link>
            </div>
          </div>
        )}
      </div>
    </React.Fragment>
  );
}
